import { LegacyUrlService } from "../services/LegacyUrl";
import { ISettingsService } from "../typings/typings";

export class NewsRssController {
    public feedUrl: string;
    public allNews: string;
    public maxNews: number;
    public showImages = false;
    public characterLimit: number;
    public newsList: any[] = [];

    public static $inject = ["$resource", "LegacyUrlService", "SettingsService"];
    constructor(private $resource, private LegacyUrlService: LegacyUrlService, private SettingsService: ISettingsService) {}

    private isLoading() {
        return this.newsList.length === 0;
    }

    public $onChanges() {
        this.allNews = this.LegacyUrlService.getPathFromLegacyPath(this.feedUrl);
    }

    public $onInit() {
        let newsResource = this.$resource(this.SettingsService.eslapi_host + "/news/teaser?url=:url&limit=:limit");

        newsResource.query(
            {
                url: this.feedUrl,
                limit: this.maxNews,
            },
            data => {
                this.newsList = data;
            }
        );
    }
}
